import React from 'react';

type Props = {
  className?: string;
  size?: number;
  type: string;
  onClick?: () => void;
};

export const Icon: React.FC<Props> = props => {
  const { type, size, className, onClick } = props;
  return (
    <i
      className={`las ${type} ${className ? className : ''}`}
      style={{ fontSize: size }}
      onClick={onClick}
    />
  );
};

Icon.defaultProps = {
  size: 24
};
